<ifc-app-scroll-container class="scroll-container" [widgetsWithTopHeader]="true">
  <form [formGroup]="form">
    <ifc-app-card>
      <ifb-account-facility-card>
          <mat-form-field appearance="outline">
            <mat-label>{{data.facilitiesReadAllowed  ? 'Facility' : 'No facilities permission'}}</mat-label>
            <mat-select
              formControlName="facility"
              [disabled]="!data.facilitiesReadAllowed"
            >
              <mat-select-trigger>
                <span
                [matTooltip]="getDisabledOptionTooltip(form.controls.facility.value)"
                matTooltipPosition="right"
              >
                <mat-icon *ngIf="!form.controls.facility?.value?.isDefault && form.controls.facility?.value?.maximumAcceptableLoanCreditLimit < data.accountData?.offer?.amount"
                  class="mat-orange warning-icon">warning</mat-icon>
                {{ form.controls.facility?.value?.name }}
              </span> 
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of data?.facilitiesOptions?.values"
                [value]="option"
                [disabled]="!data.adminWriteAllowed && !option.isDefault && option.maximumAcceptableLoanCreditLimit < data.accountData?.offer?.amount"              
              >
                <span
                  [matTooltip]="getDisabledOptionTooltip(option)"
                  matTooltipPosition="right"
                >
                <mat-icon *ngIf="!option.isDefault && option.maximumAcceptableLoanCreditLimit < data.accountData?.offer?.amount"
                   class="mat-orange warning-icon">warning</mat-icon>
                  {{ option.name }}
                </span>
              </mat-option>
            </mat-select>
            <mat-error>Please select facility.</mat-error>
          </mat-form-field>
      </ifb-account-facility-card>

      <aside class="flex column app-card-aside">
        <ifb-account-facility-card>
          <h2 class="heading">Details</h2>
          <div
            *ngIf="data?.dataSource?.currentFacility?.name"
            class="layout padding-top"
          >
            <div>{{ data.dataSource?.currentFacility?.name }}</div>
            <p class="label">Facility name</p>
          </div>

          <div *ngIf="data?.dataSource?.currentFacility?.seniorLenders?.length > 0" class="layout">
            <div>
              <ng-container *ngFor="let lenderName of data?.dataSource?.currentFacility?.seniorLenders; let isLast = last">
                {{ lenderName }}<span *ngIf="!isLast">, </span>
              </ng-container>
            </div>
            <p class="label">Senior lenders</p>
          </div>

          <div *ngIf="data?.dataSource?.currentFacility?.mezzanineLenders?.length > 0" class="layout">
            <div>
              <ng-container *ngFor="let lenderName of data?.dataSource?.currentFacility?.mezzanineLenders; let isLast = last">
                {{ lenderName }}<span *ngIf="!isLast">, </span>
              </ng-container>
            </div>
            <p class="label">Mezzanine lenders</p>
          </div>

          <h3 *ngIf="data?.dataSource?.history?.length > 0" class="heading">Activity</h3>
          <div *ngIf="data?.dataSource?.history?.length > 0" class="layout">
            <div
              *ngFor="let facilityHistory of data?.dataSource?.history.slice().reverse(); 
                      let isLast = last;
                      let i = index "
              class="layout padding-top"
            >
            <div>{{ facilityHistory | facitlityHistoryAssignementLabel }}</div>
              <p class="label">{{ facilityHistory.initiatedOnUtc | date: 'medium' }}</p>
            </div>
          </div>
        </ifb-account-facility-card>
      </aside>
    </ifc-app-card>
  </form>
  </ifc-app-scroll-container>
  